import { render, staticRenderFns } from "./cusCheckDetails.vue?vue&type=template&id=6642637f&"
import script from "./cusCheckDetails.vue?vue&type=script&lang=js&"
export * from "./cusCheckDetails.vue?vue&type=script&lang=js&"
import style0 from "./cusCheckDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports